import { type FunctionComponent, lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCuratePageProjectScenarioRules = lazy(() => {
  return new Promise<{ default: FunctionComponent }>((resolve, reject) => {
    import("@honeycomb/curate/curate.css");
    import("@honeycomb/curate")
      .then((lib) => {
        resolve({
          default: () => <lib.PageProjectScenarioRules />,
        });
      })
      .catch(reject);
  });
});

export const LazyCuratePageProjectScenarioRules = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCuratePageProjectScenarioRules />
    </Suspense>
  );
};
